import { Tooltip } from 'antd';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { AIFill20 } from 'components/atoms/icons/ai-fill';

interface Props {
  editor?: any;
}
export const AIFillSelectorTrigger: FC<Props> = ({ editor }) => {
  const insertAIFillSelectorTrigger = useCallback(() => {
    if (editor == null) {
      return;
    }
    editor.editing.view.focus();
    editor.model.change((writer) => {
      editor.model.insertContent(writer.createText(' /'));
      editor.editing.view.focus();
      // Adding scrolltoselection to fix the bug where if the cursor is out of screen and
      // selecting AI Fill from toolbar will crash the page.
      editor.editing.view?.scrollToTheSelection();
    });
  }, [editor]);

  return (
    <Tooltip title={<FormattedMessage id="toolbar.ai_fill" />}>
      <Button
        icon={<AIFill20 />}
        type="text"
        onClick={insertAIFillSelectorTrigger}
      />
    </Tooltip>
  );
};
